import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    loginError: {},
    loginData: {},
    message: null,
    loading: false,
    OTPSend: false,
    resendOTP: false,
    showResentOTP: false,
  },
  reducers: {
    cleardata: (state, action) => {
      return {
        ...state,
        loginError: {},
        loginData: {},
        message: null,
        loading: false,
        OTPSend: false,
      };
    },
    checkLogin: (state, action) => {
      return {
        ...state,
        loading: true,
        loginError: {},
      };
    },
    loginUserSuccessful: (state, action) => {
      return { ...state, loading: false, loginError: {} };
    },
    getOTPRequest: (state, action) => {
      return {
        ...state,
        loading: true,
        loginError: {},
      };
    },
    OTPRequestSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        loginError: {},
        OTPSend: action.payload,
      };
    },
    logoutUser: (state, action) => {
      return { ...state };
    },
    logoutUserSuccess: (state, action) => {
      return { ...state };
    },
    logoutUserFromAllDevices: (state, action) => {
      return { ...state };
    },
    logoutUserFromAllDevicesSuccess: (state, action) => {
      return { ...state };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        loginData: {
          ...state.loginData,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    getResendOTP: (state, action) => {
      return {
        ...state,
        loading: true,
        loginError: {},
      };
    },
    resendOTPSuccessful: (state, action) => {
      return {
        ...state,
        loading: false,
        loginError: {},
        resendOTP: action.payload,
      };
    },
    showResend:(state, action) => {
      return {
        ...state,
        loading: true,
        showResentOTP: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, loginError: action.payload };
    },
  },
});
export const {
  cleardata,
  checkLogin,
  loginUserSuccessful,
  getOTPRequest,
  OTPRequestSuccessful,
  logoutUser,
  logoutUserSuccess,
  logoutUserFromAllDevices,
  logoutUserFromAllDevicesSuccess,
  InputChangeValue,
  getResendOTP,
  resendOTPSuccessful,
  showResend,
  apiError,
} = loginSlice.actions;

export default loginSlice.reducer;
